<template>
  <v-container>
    <LoggedIn v-if="isLoggedIn && isRegistered" :guideStart="true" />
    <LoggedOut v-else />
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import LoggedIn from '@/components/Start/LoggedIn'
import LoggedOut from '@/components/Start/LoggedOut'

export default {
  name: 'Guide',

  components: {
    LoggedOut,    
    LoggedIn
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isLoggedIn', 'isRegistered'])
  },

  created() {}
}
</script>

<style>
</style>            